
import Menu from '~/components/header/Menu.vue';
import MobileMenuContent from '~/components/header/mobile/MobileMenuContent';
import SearchInput from '~/components/widgets/SearchHome/SearchInput/SearchInput';
import ControlsLink from '~/components/header/ControlsLinks';
import { ymGoalCheck } from '~/helpers/ym_helper';

export default {
  name: 'TheHeader',
  emits: ['onSelectCity'],
  data() {
    return {
      isOpenedSidebar: false,
      isFixed: false,
      headerHeight: 0,
    };
  },

  components: {
    ControlsLink,
    SearchInput,
    MobileMenuContent,
    Menu,
    LazyCatalog: () => import('~/components/header/mobile/LazyCatalog.vue'),
    LazyMobileSidebar: () => import('~/components/common/LazyMobileSidebar'),
  },

  props: {
    menu: {
      type: Array,
      default: () => [],
    },

    catalog: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    appCfg() {
      return this.$store.getters['appState/config'];
    },
    currentCity() {
      return this.appCfg?.city?.model?.name || 'Екатеринбург';
    },

    getSubdomain() {
      const currHost = this.$store.getters['local-settings/currentHost'];
      return currHost ? `https://${currHost}` : 'https://centraltrans.ru/';
    },

    vars() {
      return this.$store.state?.appState?.vars || {};
    },

    isMobile() {
      return this.$store.getters['mobile-menu/isMobile'];
    },

    isMenuOpened() {
      return this.$store.getters['mobile-menu/isOpen'];
    },

    cartItems() {
      const itemsCount = this.$store.getters['cart/itemsCount'];
      const totalSum = this.$store.getters['cart/totalSum'];
      return { itemsCount, totalSum };
    },

    contactEmail() {
      return this.vars?.email || 'zakaz@pdn66.ru';
    },
    watsappNumber() {
      return this.vars.whatsapp || '';
    },
    contactAddress() {
      return this?.vars['адрес'] || 'Сибирский тракт 12/1А, оф 604';
    },
    contactPhone() {
      return this.$store.state.currentPhone.currentPhone || '88002004897';
    },

    isHomePage() {
      return this.$route?.path === '/';
    },
  },

  methods: {
    emailHandler({ target }) {
      if (process.client) {
        if (window.screen.width > 1023) {
          navigator.clipboard.writeText(target.innerText);
          this.$toast.success('Email скопирован');
        }
      }
    },
    openAuth() {
      this.$store.commit('authRegistration/setOpen', {
        name: 'isOpenAuth',
        value: true,
      });
    },
    openCallbackModal() {
      this.$store.commit('pop-up-back-call/openCallbackPopup', {
        yandexMetriks: {
          ymGoal: 'zapros_zvonok_sent',
          ymNumber: process.env.yandexMetriks,
        },
      });

      ymGoalCheck({
        ymGoal: 'zapros_zvonok_form',
        ymNumber: process.env.yandexMetriks,
      });
    },
    openCityModal() {
      this.$store.commit('city-select/setOpen', true);
    },
    switchMobileSidebar() {
      this.$store.commit('mobile-menu/switchBtn', !this.isMenuOpened);
    },
    handleScroll({ target }) {
      this.headerHeight = document.getElementById('header').offsetHeight;

      const isFixed = Boolean((target?.scrollingElement?.scrollTop || 0) > this.headerHeight);

      if (this.isFixed !== isFixed) {
        this.isFixed = isFixed;
      }
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  unMounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
